'use client';

import { useState } from 'react';
import Link from 'next/link';
import { 
  ShieldCheck, ArrowRight, Menu, Phone, Mail, Linkedin, Instagram, Youtube,
  BookOpen, FileText, Activity, ShieldAlert, Boxes, Target, CheckCircle2, 
  AlertTriangle, Lightbulb, RefreshCw, HardHat, X, ChevronRight
} from 'lucide-react';

export default function ConteudosPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const wppLink = "https://wa.me/554888796761?text=Quero%20saber%20mais%20sobre%20os%20conteúdos%20da%20Nexus%20Safe.";
  const appLink = "https://app.nexussafe.com.br/";

  return (
    <div className="min-h-screen bg-white selection:bg-blue-200 selection:text-blue-900 font-sans text-gray-800 relative flex flex-col overflow-x-hidden">
      
      {/* ================= FIO LATERAL COLORIDO ================= */}
      <div className="hidden sm:block" style={{
        position: 'fixed', top: 0, left: '24px', width: '6px', height: '100vh',
        background: 'linear-gradient(to bottom, #06b6d4, #3b82f6, #8b5cf6, #ec4899)', 
        zIndex: 99999, boxShadow: '0 0 15px rgba(59, 130, 246, 0.4)'
      }}></div>

      {/* ================= NAVBAR ================= */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 shadow-sm top-0">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative">
          <div className="flex items-center shrink-0 h-full">
            <Link href="/" className="flex items-center">
              <img src="/logo-nexus.png" alt="NexusSafe" style={{ height: '40px', width: 'auto' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if(fallback) fallback.style.display = 'flex';
                }}
              />
              <div style={{ display: 'none' }} className="items-center gap-2">
                <ShieldCheck size={28} className="text-gray-900" />
                <span className="text-xl font-black text-gray-900 tracking-tight">NEXUS<span className="font-light">SAFE</span></span>
              </div>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center gap-4 lg:gap-8 font-bold text-sm text-gray-600">
            <Link href="/site/solucoes" className="hover:text-blue-600 transition-colors">Soluções</Link>
            <Link href="/site/para-quem-e" className="hover:text-blue-600 transition-colors">Para quem é</Link>
            <Link href="/site/recursos" className="hover:text-blue-600 transition-colors">Recursos</Link>
            <Link href="/site/conteudos" className="text-blue-600 transition-colors">Conteúdos</Link>
            <Link href="/site/sobre-nos" className="hover:text-blue-600 transition-colors">Sobre nós</Link>
          </div>

          <div className="flex items-center gap-4 text-sm font-bold shrink-0">
            <div className="hidden md:flex items-center gap-4">
              <a href={appLink} className="text-gray-800 hover:text-blue-600 transition-colors border-r border-gray-300 pr-4">Entrar</a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2.5 rounded-full hover:bg-blue-700 transition-all flex items-center gap-2 shadow-lg shadow-blue-600/20 whitespace-nowrap">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
            
            {/* Ícone Menu Mobile - Só aparece no celular (md:hidden) */}
            <button 
              className="md:hidden text-gray-800 p-2 transition-colors hover:text-blue-600"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Alternar menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* ================= MENU MOBILE (DROPDOWN) ================= */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full bg-white shadow-xl border-t border-gray-100 flex flex-col p-6 gap-4 z-40 max-h-[calc(100vh-80px)] overflow-y-auto">
            <Link href="/site/solucoes" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Soluções <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/para-quem-e" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Para quem é <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/recursos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Recursos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/conteudos" onClick={() => setIsMobileMenuOpen(false)} className="text-blue-600 font-bold py-3 border-b border-gray-50 flex justify-between items-center">
              Conteúdos <ChevronRight size={16} className="text-blue-400" />
            </Link>
            <Link href="/site/sobre-nos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Sobre nós <ChevronRight size={16} className="text-gray-400" />
            </Link>
            
            <div className="flex flex-col gap-3 mt-4">
              <a href={appLink} className="w-full text-center text-gray-900 font-bold py-3.5 border-2 border-gray-200 rounded-full hover:bg-gray-50 transition-colors">
                Entrar no Sistema
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full bg-blue-600 text-white py-3.5 rounded-full font-bold hover:bg-blue-700 transition-all flex justify-center items-center gap-2 shadow-lg shadow-blue-600/20">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* ================= HERO SECTION ================= */}
      <section className="pt-40 pb-16 px-6 bg-gray-50 border-b border-gray-100">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <div className="text-blue-600 font-bold text-sm tracking-widest uppercase"><BookOpen size={16} className="inline mr-2 -mt-1"/>Base de Conhecimento</div>
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 leading-[1.1] tracking-tight">
            Conteúdos exclusivos de <span className="text-blue-600">SST</span>
          </h1>
          <p className="text-lg text-gray-500 font-medium leading-relaxed max-w-2xl mx-auto">
            Aprenda sobre normas, ferramentas de gestão, tendências e como otimizar a segurança da sua equipe explorando nossos artigos técnicos completos.
          </p>
        </div>
      </section>

      {/* ================= ARTIGOS COMPLETOS ================= */}
      <section className="py-20 px-6 max-w-4xl mx-auto space-y-24">
        
        {/* ARTIGO 1: NR-01 */}
        <article className="scroll-mt-32">
          <div className="bg-blue-50/50 rounded-3xl border border-blue-100 overflow-hidden shadow-sm">
            <div className="h-40 bg-blue-600 flex items-center justify-center relative overflow-hidden">
              <Activity size={120} className="text-blue-500 absolute -right-6 -bottom-6 transform rotate-12 opacity-50" />
              <ShieldAlert size={120} className="text-blue-500 absolute -left-6 -top-6 transform -rotate-12 opacity-50" />
              <h2 className="text-4xl font-black text-white uppercase tracking-widest z-10 shadow-black/10 drop-shadow-md">NR-01 e Psicossocial</h2>
            </div>
            <div className="p-8 md:p-12">
              <div className="flex items-center gap-2 text-xs font-black text-blue-600 uppercase tracking-widest mb-4">
                <ShieldAlert size={14}/> Gestão de Riscos Ocupacionais
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-6 leading-tight">
                A Importância do Questionário NR-01 para Riscos Psicossociais
              </h3>
              
              <div className="space-y-6 text-gray-600 leading-relaxed font-medium">
                <p>
                  Com as recentes atualizações normativas, a NR-01 tornou obrigatório o mapeamento e controle dos <strong>Riscos Psicossociais</strong> dentro do Programa de Gerenciamento de Riscos (PGR). Ignorar essa exigência não apenas expõe a empresa a multas pesadas, mas contribui diretamente para o aumento de afastamentos por <em>Burnout</em>, depressão e ansiedade.
                </p>
                <p>
                  Muitas empresas cometem o erro de preencher o PGR apenas com base na visão da diretoria — o que chamamos de <strong>"Miopia Gerencial"</strong>. A liderança acredita que o ambiente é saudável porque existem regras no papel, mas a operação sofre com metas abusivas, falta de clareza ou assédio moral.
                </p>
                
                <div className="bg-white p-6 rounded-2xl border border-blue-100 shadow-sm my-8">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Lightbulb className="text-yellow-500" size={20}/> Como a NexusSafe resolve esse desafio?
                  </h4>
                  <p className="mb-4 text-sm">Nossa metodologia realiza uma <strong>Triangulação de Dados</strong> exclusiva:</p>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-blue-600 shrink-0 mt-0.5" size={18}/> <span><strong>Diagnóstico da Gestão:</strong> O RH ou SESMT responde a 23 perguntas sobre processos, PCCS e políticas internas.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-blue-600 shrink-0 mt-0.5" size={18}/> <span><strong>EET (Escala de Estresse no Trabalho):</strong> Os colaboradores respondem anonimamente a um questionário validado cientificamente via WhatsApp.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-blue-600 shrink-0 mt-0.5" size={18}/> <span><strong>Cruzamento de Dados:</strong> O sistema aponta exatamente onde a visão da empresa diverge da realidade do colaborador, gerando o risco real.</span></li>
                  </ul>
                </div>

                <p>
                  Ao automatizar esse processo, você protege a saúde mental dos seus trabalhadores, garante a conformidade com a NR-01 e gera Planos de Ação baseados em dados reais, não em "achismos".
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* ARTIGO 2: CHECKLISTS */}
        <article className="scroll-mt-32">
          <div className="bg-orange-50/50 rounded-3xl border border-orange-100 overflow-hidden shadow-sm">
            <div className="h-40 bg-orange-500 flex items-center justify-center relative overflow-hidden">
              <FileText size={120} className="text-orange-400 absolute -right-6 -bottom-6 transform rotate-12 opacity-50" />
              <CheckCircle2 size={120} className="text-orange-400 absolute -left-6 -top-6 transform -rotate-12 opacity-50" />
              <h2 className="text-4xl font-black text-white uppercase tracking-widest z-10 shadow-black/10 drop-shadow-md">Inspeções Digitais</h2>
            </div>
            <div className="p-8 md:p-12">
              <div className="flex items-center gap-2 text-xs font-black text-orange-600 uppercase tracking-widest mb-4">
                <FileText size={14}/> Padronização e Conformidade
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-6 leading-tight">
                Como Digitalizar Checklists de SST e Evitar Passivos Trabalhistas
              </h3>
              
              <div className="space-y-6 text-gray-600 leading-relaxed font-medium">
                <p>
                  O uso de pranchetas de papel para realizar inspeções de rotina (veículos, extintores, maquinários) é um dos maiores pontos de falha na gestão de Segurança do Trabalho. Papéis rasgam, molham, são preenchidos com "vistos fantasmas" (sem o técnico ir ao local) e, principalmente, demoram dias para chegar às mãos de quem pode resolver o problema.
                </p>
                <p>
                  Quando ocorre um acidente, a falta de uma evidência sólida de que a máquina havia sido inspecionada corretamente pode custar milhões à organização em processos indenizatórios e criminais.
                </p>
                
                <div className="bg-white p-6 rounded-2xl border border-orange-100 shadow-sm my-8">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <AlertTriangle className="text-orange-500" size={20}/> A Revolução do Checklist Mobile
                  </h4>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-orange-600 shrink-0 mt-0.5" size={18}/> <span><strong>Evidências Fotográficas:</strong> O inspetor é obrigado a tirar fotos em tempo real das não-conformidades encontradas no equipamento.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-orange-600 shrink-0 mt-0.5" size={18}/> <span><strong>Assinatura na Tela e GPS:</strong> O sistema rastreia a localização do dispositivo para comprovar que o profissional realmente estava no local de risco no horário informado.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-orange-600 shrink-0 mt-0.5" size={18}/> <span><strong>Geração Direta de PDCA:</strong> Se um item crítico for marcado como "Inconforme", o sistema alerta os gestores instantaneamente.</span></li>
                  </ul>
                </div>

                <p>
                  A digitalização transforma a inspeção de uma mera formalidade burocrática em uma ferramenta ativa de prevenção, garantindo rastreabilidade perfeita em caso de auditorias do Ministério do Trabalho.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* ARTIGO 3: PLANOS DE AÇÃO */}
        <article className="scroll-mt-32">
          <div className="bg-green-50/50 rounded-3xl border border-green-100 overflow-hidden shadow-sm">
            <div className="h-40 bg-green-600 flex items-center justify-center relative overflow-hidden">
              <Target size={120} className="text-green-500 absolute -right-6 -bottom-6 transform -rotate-12 opacity-50" />
              <RefreshCw size={120} className="text-green-500 absolute -left-6 -top-6 transform rotate-12 opacity-50" />
              <h2 className="text-4xl font-black text-white uppercase tracking-widest z-10 shadow-black/10 drop-shadow-md">Ciclo P.D.C.A.</h2>
            </div>
            <div className="p-8 md:p-12">
              <div className="flex items-center gap-2 text-xs font-black text-green-600 uppercase tracking-widest mb-4">
                <Target size={14}/> Melhoria Contínua
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-6 leading-tight">
                Do Diagnóstico à Solução: A Metodologia dos Planos de Ação
              </h3>
              
              <div className="space-y-6 text-gray-600 leading-relaxed font-medium">
                <p>
                  Identificar um risco ou uma não-conformidade é apenas o primeiro passo. O grande gargalo das empresas não está em "descobrir" os problemas, mas sim na incapacidade de resolvê-los. Relatórios de inspeção frequentemente acabam esquecidos em gavetas porque não há um fluxo claro de responsabilização.
                </p>
                <p>
                  É aqui que entra o ciclo <strong>PDCA (Plan, Do, Check, Act)</strong> integrado. Ao transformar qualquer falha imediatamente em um Plano de Ação, você garante que as medidas corretivas saiam do papel.
                </p>
                
                <div className="bg-white p-6 rounded-2xl border border-green-100 shadow-sm my-8">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Activity className="text-green-600" size={20}/> Estruturando Ações com Matriz GUT
                  </h4>
                  <p className="mb-4 text-sm">O sistema da NexusSafe eleva a gestão de tarefas aplicando parâmetros automáticos de risco:</p>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={18}/> <span><strong>Priorização Matemática:</strong> Cada plano recebe uma nota de Gravidade, Urgência e Tendência (Matriz GUT), forçando a equipe a focar no que pode causar acidentes graves primeiro.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={18}/> <span><strong>Designação de Responsáveis (5W2H):</strong> Define-se claramente "Quem" vai fazer, "Quando" é o prazo limite e "Quanto" custará.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={18}/> <span><strong>Assinatura de Eficácia:</strong> Após a tarefa ser concluída (ex: trocar a grade de uma máquina), o SESMT precisa assinar validando se a ação realmente eliminou o risco.</span></li>
                  </ul>
                </div>

                <p>
                  Uma gestão de Saúde e Segurança madura não é aquela que não tem acidentes no histórico, mas sim aquela que possui processos documentados provando que age proativamente para evitá-los.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* ARTIGO 4: EPI */}
        <article className="scroll-mt-32">
          <div className="bg-purple-50/50 rounded-3xl border border-purple-100 overflow-hidden shadow-sm">
            <div className="h-40 bg-purple-600 flex items-center justify-center relative overflow-hidden">
              <HardHat size={120} className="text-purple-500 absolute -right-6 -bottom-6 transform rotate-12 opacity-50" />
              <Boxes size={120} className="text-purple-500 absolute -left-6 -top-6 transform -rotate-12 opacity-50" />
              <h2 className="text-4xl font-black text-white uppercase tracking-widest z-10 shadow-black/10 drop-shadow-md">Gestão de E.P.I.</h2>
            </div>
            <div className="p-8 md:p-12">
              <div className="flex items-center gap-2 text-xs font-black text-purple-600 uppercase tracking-widest mb-4">
                <Boxes size={14}/> Controle de Insumos e Proteção
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-6 leading-tight">
                Controle de Estoque e Validade de C.A: Reduzindo Custos e Riscos
              </h3>
              
              <div className="space-y-6 text-gray-600 leading-relaxed font-medium">
                <p>
                  Equipamentos de Proteção Individual (EPIs) são a última barreira entre o trabalhador e o acidente. No entanto, a gestão ineficiente de EPIs causa dois problemas massivos: <strong>desperdício financeiro</strong> (entregas excessivas ou sem controle) e <strong>insegurança jurídica</strong> (falta da assinatura do colaborador comprovando o recebimento).
                </p>
                <p>
                  A Norma Regulamentadora NR-06 é clara: o empregador é obrigado a fornecer equipamento aprovado, orientar sobre o uso e <em>registrar rigorosamente</em> o fornecimento.
                </p>
                
                <div className="bg-white p-6 rounded-2xl border border-purple-100 shadow-sm my-8">
                  <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <ShieldCheck className="text-purple-600" size={20}/> Como a Digitalização Protege a Empresa
                  </h4>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-purple-600 shrink-0 mt-0.5" size={18}/> <span><strong>Validade de C.A. (Certificado de Aprovação):</strong> O sistema impede a entrega de EPIs com certificado vencido junto ao Ministério do Trabalho.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-purple-600 shrink-0 mt-0.5" size={18}/> <span><strong>Ficha de EPI Digital:</strong> O almoxarifado usa um tablet onde o funcionário assina com o dedo ou biometria. Adeus pilhas de fichas de papel rasgadas.</span></li>
                    <li className="flex items-start gap-3"><CheckCircle2 className="text-purple-600 shrink-0 mt-0.5" size={18}/> <span><strong>Alertas de Troca:</strong> O sistema notifica automaticamente quando o tempo de vida útil do EPI fornecido (ex: botina vence a cada 6 meses) está chegando ao fim.</span></li>
                  </ul>
                </div>

                <p>
                  Automatizar o estoque de EPI garante que você saiba exatamente o custo de proteção por funcionário e por setor, transformando uma obrigação legal em inteligência de negócios e redução de sinistralidade.
                </p>
              </div>
            </div>
          </div>
        </article>

      </section>

      {/* ================= CALL TO ACTION (CTA) ================= */}
      <section className="py-20 px-6 bg-gray-900 text-center relative overflow-hidden">
        <div className="max-w-3xl mx-auto relative z-10">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6">Pronto para colocar a teoria na prática?</h2>
          <p className="text-gray-400 font-medium mb-10 text-lg">
            Nossa plataforma já aplica automaticamente todos esses conceitos no seu dia a dia. Agende uma demonstração e veja o NexusSafe funcionando.
          </p>
          <a href={wppLink} target="_blank" rel="noopener noreferrer" className="inline-flex bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-sm hover:bg-blue-700 transition-all items-center gap-2 shadow-xl shadow-blue-600/30 hover:scale-105 active:scale-95">
            Agendar Demonstração <ArrowRight size={18} />
          </a>
        </div>
        <div className="absolute right-0 bottom-0 w-[600px] h-[600px] border-[60px] border-blue-600/10 rounded-full translate-x-1/3 translate-y-1/3 pointer-events-none"></div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer style={{ backgroundColor: '#020617', paddingTop: '100px', paddingBottom: '40px' }} className="font-medium mt-auto border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 border-b border-gray-800 pb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-6">
              <Link href="/" className="flex items-center">
                <img src="/logo-nexus-branca.png" alt="NexusSafe" style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const fallback = target.nextElementSibling as HTMLElement;
                    if(fallback) fallback.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none' }} className="items-center gap-2">
                  <ShieldCheck size={28} className="text-white" />
                  <span className="text-xl font-black text-white tracking-tight">NEXUSSAFE</span>
                </div>
              </Link>
            </div>
            <p style={{ color: '#9CA3AF' }} className="text-sm leading-relaxed mb-8">
              A plataforma inteligente que simplifica a gestão de Segurança e Saúde do Trabalho e conecta pessoas, dados e resultados.
            </p>
            <div className="flex gap-4">
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Linkedin size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Instagram size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Youtube size={18} /></a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Soluções</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Psicossocial + Plano</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Canal de Denúncia</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Checklist</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Plano de Ação</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Entrega de EPI</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Questionários</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">CIPA</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Para quem é</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Indústrias</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Construtoras</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Comércio</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Serviços</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Saúde</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Educação</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Recursos</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-8">
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Blog</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Materiais</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Webinars</Link></li>
              <li><Link href="/site/recursos" className="hover:text-white transition-colors">Cases</Link></li>
            </ul>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Sobre Nós</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Institucional</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Parceiros</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Fale Conosco</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-3"><Phone size={14} className="shrink-0"/> (48) 9.8879-6761</li>
              <li className="flex items-center gap-3"><Mail size={14} className="shrink-0"/> comercial@nexussafe.com.br</li>
            </ul>
            <a href={wppLink} target="_blank" rel="noopener noreferrer" className="inline-flex bg-blue-600 text-white px-5 py-2.5 rounded-full font-bold text-xs hover:bg-blue-700 transition-all items-center gap-2">
              Fale com um especialista <ArrowRight size={14} />
            </a>
          </div>
        </div>
        <div style={{ color: '#9CA3AF' }} className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p className="text-center md:text-left">© 2026 NexusSafe - Criado por Leandro Rodrigo de Oliveira - Todos os direitos reservados</p>
          <div className="flex items-center gap-6">
            <a href="https://nexussafe.com.br/site/privacidade" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Política de Privacidade</a>
            <a href="https://nexussafe.com.br/site/termos" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Termos de Uso</a>
          </div>
        </div>
      </footer>
    </div>
  );
}